import * as React from 'react';
import type { SVGProps } from 'react';
const SvgVerticalBarsStacked = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={297}
    height={252}
    fill="none"
    viewBox="0 0 33 28"
    {...props}
  >
    <path
      fill="var(--color-content-status-neutral-secondary)"
      fillRule="evenodd"
      d="M7.08 23.725h4.742v-9.42H7.08z"
      clipRule="evenodd"
    />
    <path
      fill="var(--color-surface-interactive-secondary-default)"
      fillRule="evenodd"
      d="M7.08 14.918h4.74V5.273c0-.749-.606-1.355-1.354-1.355h-2.03c-.749 0-1.355.606-1.355 1.355v9.645Z"
      clipRule="evenodd"
    />
    <path
      fill="var(--color-content-status-neutral-secondary)"
      fillRule="evenodd"
      d="M14.532 23.724h4.741v-6.48h-4.741z"
      clipRule="evenodd"
    />
    <path
      fill="var(--color-surface-interactive-secondary-default)"
      fillRule="evenodd"
      d="M14.532 18.917h4.74v-7.645c0-.748-.607-1.355-1.355-1.355h-2.03c-.749 0-1.355.607-1.355 1.355z"
      clipRule="evenodd"
    />
    <path
      fill="var(--color-content-status-neutral-secondary)"
      fillRule="evenodd"
      d="M21.983 23.726h4.741V15.6h-4.741v8.127Z"
      clipRule="evenodd"
    />
    <path
      fill="var(--color-surface-interactive-secondary-default)"
      fillRule="evenodd"
      d="M21.983 15.918h4.74V8.273c0-.749-.607-1.355-1.355-1.355h-2.03c-.749 0-1.355.606-1.355 1.355z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgVerticalBarsStacked;
